import WaitingRoomEmptyState from './WaitingRoomEmptyState.component';

export default WaitingRoomEmptyState;
